export function __makeId(length = 16) {
    let result = "";
    const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const firstCharacters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    for (let i = 0; i < length; i++) {
        const chars = i ? characters : firstCharacters;
        const length = chars.length;
        result += chars.charAt(Math.floor(Math.random() * length));
    }
    return result;
}

export function __copyObject(obj){
    return JSON.parse(JSON.stringify(obj));
}

export function __getTree(
    items,
    parentId = null,
    options = {parentKey: 'parent_id', childrenKey: 'children'}
) {
    const children = items.filter(item => {
        const itemParentId = item[options.parentKey] ?? null;
        return itemParentId === parentId;
    });

    const left = items.filter(item => {
        const itemParentId = item[options.parentKey] ?? null;
        return itemParentId !== parentId;
    });

    return children.map(child => {
        child[options.childrenKey] = __getTree(left, child.id, options);
        return child;
    });
}

export function __dataId(element) {
    const onlyDigits = (str) => /^\d+$/.test(str)
    const dataId = element.getAttribute('data-id');
    return onlyDigits(dataId) ? parseInt(dataId) : dataId;
}

export function __keyToName(key) {
    if (!key) {
        return null;
    }

    key = key
        .replaceAll(".blade.php", "")
        .replaceAll(".blade", "")
    key = key.split('_').join(' ');
    key = key.split('-').join(' ');
    return (key?.[0]?.toUpperCase() + key?.slice(1));
}

export function __windowDownload(name, url) {
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    a.download = name;
    a.click();
    window.URL.revokeObjectURL(url);
}

export function __getStreamFilename(response, alterName) {
    const disposition =
        response.headers["Content-Disposition"] ||
        response.headers["content-disposition"];
    let filename = null;
    if (disposition && disposition.indexOf("attachment") !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
        }
    } else {
        console.error("Content-Disposition and Content-Type is not set up!");
        filename = alterName.split("/").join(" ");
    }
    return filename;
}

export function __downloadStreamResponse(response, alterName) {
    const fileName = __getStreamFilename(response, alterName);
    const fileUrl = URL.createObjectURL(response.data);
    __windowDownload(fileName, fileUrl);
}

export function __downloadStream(url, params = {}, method = "GET") {
    const options = {
        method: method,
        url: url,
        params: params,
        responseType: "blob",
    };
    return axios.request(options).then(r => __downloadStreamResponse(r, url));
}

export function  __openDownloadStream(url) {
    axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
    })
        .then((response) => {
            const mimeType = response.headers['content-type'];
            const viewableBlob = new Blob([response.data], { type: mimeType });
            const fileURL = URL.createObjectURL(viewableBlob);
            window.open(fileURL, '_blank');
        })
        .catch(error => console.error(error));
}

export function __safeBtoa(str) {
    const bytes = new TextEncoder().encode(str == null ? '' : String(str));
    const chunkSize = 0x8000;
    const chunks = [];

    // Spread of a huge TypedArray blows the call stack; encode in chunks.
    for (let i = 0; i < bytes.length; i += chunkSize) {
        chunks.push(String.fromCharCode.apply(null, bytes.subarray(i, i + chunkSize)));
    }

    return btoa(chunks.join(''));
}

export function __safeAtob(base64) {
    const binString = atob(base64);
    const bytes = Uint8Array.from(binString, (m) => m.codePointAt(0));
    return new TextDecoder().decode(bytes);
}

export function __formatFileSize(bites) {
    if (bites === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bites) / Math.log(k));
    return Math.round(bites / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
}

export function __isHTML(content) {
    return /<[a-z][\s\S]*>|&[a-z\d#]+;/i.test(content)
}

export function __route(path, store) {
    const basePath = store.state.default.path;
    const fullRoute = basePath + '/' + path;

    return '/' + fullRoute.split('/').filter(i => i).join('/');
}

export function __findRoute(items, route, store) {
    let result = null;
    items.forEach(i => {
        if (!result) {
            result = i.children ?
                __findRoute(i.children, route, store) :
                (__route(i.route || '/', store) === route ? i : null);
        }
    });
    return result;
}

export function __changeRoute(path, store, route, router) {
    const newRoute = __route(path || '/', store);

    if (newRoute === route.path) {
        return;
    }

    router.push(newRoute).then(() => {})
}
